import GenericModal from "components/GenericModal";
import { useAppContextController } from "context/AppContext";
import MDTypography from "components/MDTypography";
import { useMutation } from "react-query";
import updateApplicant from "layouts/pages/applicants/actions/updateApplicant";
import AddANote from "components/AddANote";
import useDropdowns from "hooks/useDropdowns";
import postNote from "layouts/pages/applicants/actions/postNote";
import { useSnackbar } from "notistack";

const ApplicantNotesList = ({
  open,
  setOpen,
  currentApplicant,
  setCurrentApplicant,
  onSuccess,
  isCreateTaskAllowed = false,
  setTaskModalOpen,
  showType,
  saveNote: saveNoteParam,
}) => {
  const { currentLoggedUser } = useAppContextController();
  const { dropdowns: noteTypes } = useDropdowns({ entity: "noteTypes" });
  const { enqueueSnackbar } = useSnackbar();

  const updateApplicantMutation = useMutation(updateApplicant, {
    onError: (err) => {
      enqueueSnackbar(`Something went wrong! ${err}`, { variant: "error" });
    },
    onSuccess: async (_, { data }) => {
      enqueueSnackbar("Notes Have Been Successfully Updated", { variant: "success" });
      onSuccess?.();
      if (currentApplicant && setCurrentApplicant)
        setCurrentApplicant({ ...currentApplicant, ...data });
    },
  });

  const postNoteMutation = useMutation(postNote, {
    onError: (err) => {
      enqueueSnackbar(`Something went wrong! ${err}`, { variant: "error" });
    },
    onSuccess: async (_, { data }) => {
      enqueueSnackbar("Notes Have Been Successfully Updated", { variant: "success" });
      onSuccess?.(data);
      if (currentApplicant && setCurrentApplicant)
        setCurrentApplicant({
          ...currentApplicant,
          notes: [...(currentApplicant.notes ?? []), data],
        });
    },
  });

  const saveChanges = (notes) => {
    const update = async () => {
      let res;
      return updateApplicantMutation.mutateAsync({
        applicantId: currentApplicant?._id,
        data: { notes },
      });
    };
    update();
  };

  const saveNote = (noteRec) => {
    const newNote = {
      type: noteRec.type,
      text: noteRec.text,
      firstName: currentLoggedUser?.firstName,
      lastName: currentLoggedUser?.lastName,
      userId: currentLoggedUser?._id,
      date: new Date().toISOString(),
    };

    const updateNewNote = async () => {
      let res;
      return postNoteMutation.mutateAsync({ applicantId: currentApplicant?._id, data: newNote });
    };

    return updateNewNote();
  };

  const header = (
    <MDTypography
      variant="h5"
      color="dark"
      sx={{ mt: 2, mb: 1, ml: 2 }}
      key={`text_addNote_${currentApplicant?._id}`}
    >
      Add a Note For: {currentApplicant?.firstName} {currentApplicant?.lastName}
    </MDTypography>
  );

  const modalBody = (
    <AddANote
      showType={showType}
      noteTypes={noteTypes}
      setOpen={setOpen}
      saveNote={saveNoteParam || saveNote}
      saveChanges={saveChanges}
      applicant={currentApplicant}
      allowEmpty={false}
      isCreateTaskAllowed={isCreateTaskAllowed}
      setTaskModalOpen={setTaskModalOpen}
      showCurrentNotes
      showAll
    />
  );

  return (
    <>
      <GenericModal
        open={open}
        setOpen={setOpen}
        body={modalBody}
        header={header}
        sx={(theme) => ({
          width: "90% !important",
          maxWidth: "1100px !important",
          paddingBottom: "50px",
          [theme.breakpoints.down("md")]: {
            "& .MuiCardContent-root": {
              padding: "0px",
            },
          },
        })}
      />
    </>
  );
};

export default ApplicantNotesList;
